export default __webpack_public_path__ + "static/media/Shrill Bone Flute.19858869.jpg";